import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import * as React from 'react';

import { useTranslation } from 'react-i18next';

export interface DeleteDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onDelete: () => void;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({ open, setOpen, onDelete }) => {
  // eslint-disable-next-line max-len
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t('home.songbook.delete_transcription_title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`${t('home.songbook.delete_transcription_description')} `}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>{t('home.dialog.cancel')}</Button>
        <Button
          autoFocus
          onClick={() => {
            setOpen(false);
            onDelete();
          }}
        >
          {t('home.dialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
